export default __webpack_public_path__ + "static/ak-cached/24h/media/voice-remote.404deece.png";